import { render, staticRenderFns } from "./DeliveryRuleForm.vue?vue&type=template&id=584e4e69"
import script from "./DeliveryRuleForm.vue?vue&type=script&lang=js"
export * from "./DeliveryRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports